
import { useEffect, useRef, useState } from "react";
import AlreadyOpen from "./AlreadyOpen";

const CHANNEL_NAME = "home-single-tab";
const TAB_ID = crypto.randomUUID();

type Props = {
  children: React.ReactNode;
};

export function SingleTabRoute({ children }: Props) {
  const [blocked, setBlocked] = useState(false);
  const [ready, setReady] = useState(false)
  const channelRef = useRef<BroadcastChannel | null>(null);
  const isOwnerRef = useRef(true);

  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channelRef.current = channel;

    // Ask if another Home is already open
    channel.postMessage({ type: "CHECK_HOME", tabId: TAB_ID });

    channel.onmessage = (e) => {
      const { type, tabId } = e.data;

      if (type === "HOME_ACTIVE" && tabId !== TAB_ID) {
        isOwnerRef.current = false;
        setBlocked(true);
      }

      if (type === "CHECK_HOME" && isOwnerRef.current) {
        channel.postMessage({ type: "HOME_ACTIVE", tabId: TAB_ID });
      }
    };
    setReady(true);
    
    return () => {
      channel.close();
    };
  }, []);

  if (!ready) return null;


  if (blocked) {
    return <AlreadyOpen />;
  }

  return <>{children}</>;
}
